module.exports = __webpack_public_path__ + "static/img/t7.0e43b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t7.png
// module id = fNnI
// module chunks = 1